import styled, { css, keyframes } from 'styled-components';

export const waveAnimation = keyframes`
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
`;

export const Box = styled.div<{
  $borderRadius: number;
  $width: string;
  $height: string;
  $appearance: 'primary' | 'secondary';
  $as?: 'span' | 'div';
}>`
  border-radius: ${({ $borderRadius }) => `${$borderRadius}px`};
  width: ${({ $width }) => $width};
  height: ${({ $height }) => $height};
  display: block;
  animation: ${waveAnimation} 2s ease-in-out 0.5s infinite;
  background-color: ${({ theme, $appearance }) =>
    theme.palette[$appearance].background};

  ${({ $as }) =>
    $as === 'span' &&
    css`
      display: inline-block;
      vertical-align: middle;
    `}
`;
